// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import type { Icon } from 'iconsax-react';

const HistoryOutlineIcon: Icon = ({ size = 24, color, variant: _variant, className, style, ...rest }) => {
  const stroke = color || 'currentColor';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...rest}
    >
      <path
        d="M12 8V12L14 14"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.05005 11.0001C3.27414 8.80013 4.30031 6.75968 5.93278 5.26803C7.56525 3.77639 9.68974 2.93795 11.9009 2.9127C14.1121 2.88744 16.2552 3.67713 17.9213 5.1311C19.5874 6.58507 20.6599 8.60155 20.9342 10.7958C21.2085 12.99 20.6654 15.2085 19.4084 17.0278C18.1515 18.8472 16.2687 20.1401 14.1193 20.6599C11.97 21.1797 9.70446 20.89 7.75504 19.8461C5.80563 18.8022 4.30877 17.0772 3.55005 15.0001M3.05005 20.0001V15.0001H8.05005"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { HistoryOutlineIcon };
